import { Skeleton, TableCell, TableRow } from "@mui/material";
import React from "react";

export function TableRowSkeleton({ cols }: { cols: number }) {
  return (
    <TableRow>
      {new Array(cols).fill(0).map(() => (
        <TableCell>
          <Skeleton />
        </TableCell>
      ))}
    </TableRow>
  );
}
